import styled, { css } from 'styled-components';
import { rem } from 'polished';

import { Container, Row, Col } from '../../base/Grid';
import Icon from '../../base/Icon';
import Link from '../../base/Link';

export const StickyBannerContainer = styled(Container)`
  ${({ theme, isVisible, informationalBannerHeight }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const small601to769 = theme.useMediaQuery(theme.breakpoints.between(601,theme.breakpoints.values.medium));
    const small0to601 = theme.useMediaQuery(theme.breakpoints.between(0,601));
    return css`
      && {
        display: flex;
        position: fixed;
        left: ${(small601to769 || mediumUp) ? '50%' : '0'};
        top: ${((informationalBannerHeight > 0) && (small0to601))
          ? (informationalBannerHeight + 50 + 32 + 'px') // 2rem (32px) + 50px (mobile menu height) + banner height
          : ((informationalBannerHeight <= 0) && (small0to601))
            ? (rem('82px')) // 2rem + 50px (mobile menu height)
            : 0
          };
        bottom: ${(small601to769 || mediumUp) ? rem('30px') : 'unset'};
        width: ${(small601to769 || mediumUp) ? rem('600px') : 'fill-available'};
        max-width: ${rem('600px')};
        height: ${rem('90px')};
        margin-left: ${(isVisible && (small601to769 || mediumUp))
          ? rem('-300px')
          : (isVisible && small0to601)
            ? '1rem'
            : rem('-600px')
        }; // slide in from left mediumDown
        margin-right: ${(small601to769 || mediumUp) ? '0' : '1rem'};
        margin-bottom: ${!small0to601 && !isVisible ? rem('-150px') : 0}; // slide in from bottom mediumUp
        background-color: ${theme.colors.primary.blue};
        border: ${rem('1px')} solid ${theme.colors.modal.stroke};
        box-shadow: ${theme.shadows.large};
        z-index: ${theme.zIndex.stickyBanner};
        transition: ${(small601to769 || mediumUp) ? 'margin-bottom 0.2s ease-out' : 'margin-left 0.2s ease-out'};
      }
    `
  }}
`

export const StickyBannerInnerRow = styled(Row)`
  && {
    width: 100%;
  }
`

export const StickyBannerInnerCol = styled(Col)`
  ${({ theme, variant }) => {
    const small0to601 = theme.useMediaQuery(theme.breakpoints.between(0,601));
    return css`
      && {
        padding-left: ${(small0to601 && variant === 'col-right') ? rem('16px') : 0};
        padding-right: 0;
        display: inline-flex;
        align-items: center;
      }
    `
  }}
`

export const StickyBannerIcon = styled(Icon)`
  width: ${rem('57px')};
  height: ${rem('57px')};
`

export const StickyBannerLink = styled(Link)`
  ${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const small601to769 = theme.useMediaQuery(theme.breakpoints.between(601,theme.breakpoints.values.medium));
    return css`
      && {
        display: ${(small601to769 || mediumUp) ? 'inline' : 'block'};
        color: ${theme.colors.cta.yellow};
        font-size: ${(small601to769 || mediumUp) ? rem('16px') : rem('14px')};
        line-height: ${(small601to769 || mediumUp) ? rem('24px') : rem('22px')};

        &::after {
          position: relative; // TODO: add this in globally? needs testing
          top: ${rem('1px')};
          width: ${(small601to769 || mediumUp) ? rem('14px') : rem('12px')};
          height: ${(small601to769 || mediumUp) ? rem('14px') : rem('12px')};
          filter: invert(66%) sepia(75%) saturate(646%) hue-rotate(15deg) brightness(104%) contrast(101%); // $color-system-cta-yellow // TODO: this would be nice in a theme
        }
        &:hover {
          color: ${theme.colors.cta.yellowHover};
          filter: invert(48%) sepia(77%) saturate(1364%) hue-rotate(16deg) brightness(97%) contrast(101%); // $color-system-cta-hover-yellow // TODO: this would be nice in a theme
        }
      }
    `
  }}
`

export const DismissButton = styled.button`
  ${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const small601to769 = theme.useMediaQuery(theme.breakpoints.between(601,theme.breakpoints.values.medium));
    return css`
      position: absolute;
      right: ${rem('10px')};
      top: ${(small601to769 || mediumUp) ? 'unset' : 0};
      width: ${(small601to769 || mediumUp) ? rem('20px') : rem('16px')};
      height: ${(small601to769 || mediumUp) ? rem('20px') : rem('16px')};
      margin-top: ${rem('10px')};
      padding: 0;
      border: 0;
      background: transparent;
      cursor: pointer;
      ::before, ::after {
        content: '';
        width: ${rem('1px')};
        height: 100%;
        background-color: ${theme.colors.neutral.white};
        transform: rotate(45deg) translateX(0);
        position: absolute;
        left: 50%;
        top: 0;
      }
      ::before {
        transform: rotate(-45deg) translateX(0);
      }
      :hover::before, :hover::after {
        background-color: ${theme.colors.neutral.grey54};
      }
    `
  }}
`
